<template>
  <div class="view pa24">
    <el-page-header @back="goBack" content="" style="margin-bottom: 10px">
    </el-page-header>
    <div class="codeWrap">
      <el-form ref="dynamicValidateForm" :model="ruleForm" label-width="120px" class="demo-dynamic" :rules="rules">
        <!--        <el-form-item label="容器码类型">-->
        <!--          <el-radio-group v-model="ruleForm.type" @input="changeType">-->
        <!--            <el-radio :label="0">规格码</el-radio>-->
        <!--            <el-radio :label="1">空白码</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
        <el-form-item label="容器码类型">
          <el-select v-model="ruleForm.codeType" placeholder="请选择" style="width: 400px" @change="chooseCodeType">
            <el-option v-for="item in storeCodeTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-divider></el-divider>
          <div v-for="(code, index) in ruleForm.addStoreCodeDtos" :key="index">
            <div>
              <div class="orderTitle" v-if="typeShow">规格{{ index + 1 }}</div>
              <!--              <el-form-item label="是否原材料使用">-->
              <!--                <el-radio-group v-model="code.isMaterial" @input="changeType">-->
              <!--                  <el-radio :label="false">否</el-radio>-->
              <!--                  <el-radio :label="true">是</el-radio>-->
              <!--                </el-radio-group>-->
              <!--              </el-form-item>-->

              <!-- 新增一个按钮可以跳转到新增产品类别页面 -->
              <el-button class="ml10 mb10" type="primary" @click="handleAddPageClass('add', index)">+添加产品类别</el-button>
              <el-form-item label="产品类别" :prop="`addStoreCodeDtos[${index}].parentId`">
                <el-select class="main-select-tree" :ref="setClassRef(index)" clearable @clear="setValueNull(index)"
                  multiple @remove-tag="
                    (data) => {
                      delTag(data, index);
                    }
                  " v-model="code.parentName" style="width: 400px" name="option 1">
                  <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.id"
                    style="display: none" />
                  <div class="searchWrap">
                    <div class="searchItem">
                      <span class="searchName">名称</span>
                      <el-input placeholder="输入名称关键字进行过滤" v-model="filterText" style="margin: 0 5px; width: 98%">
                      </el-input>
                    </div>
                    <div class="searchItem">
                      <span class="searchName">规格</span>
                      <el-input placeholder="输入规格关键字进行过滤" v-model="specName" style="margin: 0 5px; width: 98%">
                      </el-input>
                    </div>
                    <div class="searchItem">
                      <span class="searchName">件号/存货编号</span>
                      <el-input placeholder="输入规格关键字进行过滤" v-model="partNumber" style="margin: 0 5px; width: 98%">
                      </el-input>
                    </div>
                  </div>
                  <div class="searchItem">
                  <span class="searchName">选择模式</span>
                  <el-radio-group v-model="selectionMode" style="margin: 0 5px;">
                    <el-radio :label="'single'">单选模式</el-radio>
                    <el-radio :label="'children'">包含子节点</el-radio>
                  </el-radio-group>
                </div>
                  <el-tree class="main-select-el-tree" ref="tree" :data="classList" :props="treeProps" :accordion="true"
                    highlight-current @node-click="
                      (data, node, item) =>
                        handleNodeClick(data, node, item, index)
                    " :expand-on-click-node="expandOnClickNode" collapse-tags :lazy="true" :load="load"
                    :filter-node-method="filterNode" />
                </el-select>
              </el-form-item>
              <el-form-item label="名称" :prop="`addStoreCodeDtos[${index}].name`">
                <el-input v-model="code.name" style="width: 400px" />
              </el-form-item>
              <el-form-item label="容器码数量" :prop="`addStoreCodeDtos[${index}].num`" :rules="dynamicRules(index)"
                style="width: 320px">
                <el-input-number v-model.number="code.num" :readonly="type === '3'" :min="1" />
              </el-form-item>
              <el-form-item label="所属仓库">
                <el-cascader style="width: 400px" v-model="code.warehouseIds" placeholder="请选择" :options="warehouseList"
                  :emitPath="false" :props="{ value: 'id', label: 'name', children: 'children' }"></el-cascader>
              </el-form-item>
              <el-form-item label="图片">
                <el-upload :action="uploadUrl" :headers="upParams" list-type="picture-card"
                  :class="{ disabled: uploadDisabled(index) }" :on-remove="
                    (file, fileList) => {
                      handleRemove(file, fileList, index);
                    }
                  " :on-success="
                    (response, file, fileList) => {
                      handleSuccess(response, file, fileList, index);
                    }
                  " :file-list="code.fileList" :limit="1">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="code.remarks" rows="2" style="width: 400px" />
              </el-form-item>
              <div v-if="typeShow">
                <div style="width: 50%">
                  <el-divider content-position="left">产品类别信息</el-divider>
                </div>
                <div v-for="(children, cIndex) in code.storeCodeDtos" :key="cIndex" class="children-item">
                  <el-row :gutter="20">
                    <el-col :span="10">
                      <el-form-item label="产品类别" :prop="
                          'addStoreCodeDtos.' +
                          index +
                          'storeCodeDtos.' +
                          cIndex +
                          '.classId'
                        " :rules="{
                          required: true,
                          message: '产品类别不能为空',
                          trigger: 'change',
                        }">
                        <el-select v-model="children.classId" placeholder="请选择产品类别">
                          <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="数量" :prop="
                          'addStoreCodeDtos.' +
                          index +
                          'storeCodeDtos.' +
                          cIndex +
                          '.num'
                        " :rules="[{ required: true, message: '数量不能为空' }]">
                        <el-input-number v-model.number="children.num" :readonly="type === '3'" :min="1" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-button type="primary" icon="el-icon-plus" circle
                        v-if="cIndex == code.storeCodeDtos.length - 1" @click="addClass(index)"></el-button>
                      <el-button v-if="code.storeCodeDtos.length > 1" type="danger" icon="el-icon-delete" circle
                        @click="delClass(index, cIndex)"></el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <el-button type="danger" v-if="ruleForm.addStoreCodeDtos.length > 1" @click="delSpec(index)" size="mini">
              删除项
            </el-button>
            <div style="width: 50%">
              <el-divider></el-divider>
            </div>
            <el-button type="primary" v-if="ruleForm.addStoreCodeDtos.length - 1 == index" @click="addSpec" size="mini">
              新增一项
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div class="subBtn">
      <el-button @click="goBack">取消</el-button>
      <el-button type="primary" @click="confirm">生成</el-button>
    </div>
    <AddPageClassDialog ref="addPageClassDialog" @getList="getList"></AddPageClassDialog>
    <!-- 添加原材料弹窗 -->
    <AddMaterialDialog ref="AddMaterialDialog" @getList="getList"></AddMaterialDialog>
  </div>
</template>

<script>
  import { addStoreCode } from "@/api/storeCode.js";
  import AddPageClassDialog from "../../storePageClass/component/AddPageClassDialog";
  import AddMaterialDialog from "./AddMaterialDialog.vue";
  import { noPage, pageClassList } from "@/api/customPageClass.js";
  import { fetchWarehouseTree } from "@/api/storeWarehouse.js";
  import { storeTypeList } from "@/utils/constant";
  export default {
    name: "addCode",
    components: { AddPageClassDialog, AddMaterialDialog },
    props: [],
    data() {
      let token = localStorage.getItem("token");
      return {
        selectionMode: 'single',
        title: "添加类别",
        upParams: {
          token: token,
        },
        ruleForm: {
          type: 1,
          codeType: 0,
          addStoreCodeDtos: [
            {
              num: 1,
              parentName: [],
              parentId: [],
              isMaterial: false,
              name: "",
              warehouseId: "",
              warehouseIds: "",
              storeCodeDtos: [{ classId: "", num: 1 }],
              img: "",
              remarks: "",
              fileList: [],
            },
          ],
        },
        rules: {
          "code.name": [
            { required: true, message: "请输入名称", trigger: "blur" },
          ],
          "code.codeType": [
            { required: true, message: "请选择容器类型", trigger: "blur" },
          ],
          "code.num": [
            { required: true, message: "请输入数量", trigger: "blur" },
            { type: "number", message: "数量必须为数字" },
          ],
          phone: [
            { required: true, message: "请输入联系电话", trigger: "blur" },
            {
              type: "number",
              message: "手机号格式不正确",
              trigger: "blur",
              transform(value) {
                var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
                if (!phonereg.test(value)) {
                  return false;
                } else {
                  return Number(value);
                }
              },
            },
          ],
        },
        type: "add",
        id: "",
        classList: [],
        warehouseList: [],
        typeShow: false,
        storeCodeTypeList: storeTypeList,
        treeProps: {
          children: "children",
          label: "allName",
          isLeaf: "isLeaf",
        },
        expandOnClickNode: false,
        parentId: "",
        uploadUrl: this.$store.state.uploadingUrl,
        ossUrl: this.$store.state.ossUrl,
        codeType: "",
        filterText: "",
        currentTypeIndex: null,
        specName: "",
        allData: "",
        partNumber: "",
        isInitialRender: true
      };
    },
    computed: {
      dynamicRules() {
        return (index) => {
          return [
            {
              required: true,
              message: "这是必填项",
              trigger: "blur",
            },
          ];
        };
      },
    },
    onShow() { },
    created() {
      this.changeType();
    },
    watch: {
      filterText(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.codeType,
          parentId: "",
          name: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      specName(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.codeType,
          parentId: "",
          specName: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      partNumber(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.codeType,
          parentId: "",
          partNumber: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
       selectionMode() {
          this.ruleForm.addStoreCodeDtos.forEach((_, index) => {
            this.setValueNull(index);
          });
          this.filterText = '';
          this.specName = '';
          this.partNumber = '';
        }
    },
    mounted() {
      this.ruleForm.codeType = 1;
      this.chooseCodeType();
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.allName.indexOf(value) !== -1;
      },

      getList(formData) {
        this.ruleForm.addStoreCodeDtos[this.currentTypeIndex].parentName = [
          formData.name,
        ];
        this.ruleForm.addStoreCodeDtos[this.currentTypeIndex].name =
          formData.name;
        this.ruleForm.addStoreCodeDtos[this.currentTypeIndex].parentId = [
          {
            id: formData.id,
            name: formData.name,
            parentId: formData.parentId,
            specName: formData.specName,
          },
        ];
      },
      searchItem(params, val) {
        pageClassList(params)
          .then((res) => {
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            if (res.data.list && res.data.list.length == 0) {
              this.$message.error("没有找到相关的产品类别");
            }
            if (val) {
              this.classList =
                res.data.list && res.data.list.length > 0
                  ? res.data.list
                  : this.allData;
            } else {
              this.classList = this.allData;
            }
          })
          .catch((error) => {
            console.error("接口调用出错:", error);
          });
      },
      load(node, resolve) {
        if (this.isInitialRender) {
          this.isInitialRender = false;
          return resolve([]);
        }
        if ("顶级" == node.data.allName) {
          return resolve(node.data.children);
        } else {
          let params = {
            noPage: false,
            type: 0,
            classType: this.codeType,
            parentId: node.data.id,
            name: this.filterText,
            specName: this.specName,
            partNumber: this.partNumber
          };
          pageClassList(params).then((res) => {
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            node.data.children = res.data.list;
            return resolve(res.data.list);
          });
        }
      },
      uploadDisabled(index) {
        return this.ruleForm.addStoreCodeDtos[index].img ? true : false;
      },
      handleRemove(file, fileList, index) {
        this.ruleForm.addStoreCodeDtos[index].img = "";
        this.ruleForm.addStoreCodeDtos[index].fileList = [];
      },
      handleSuccess(response, file, fileList, index) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.ruleForm.addStoreCodeDtos[index].img = file.response.data;
        this.ruleForm.addStoreCodeDtos[index].fileList.push(
          this.ossUrl + file.response.data
        );
      },
      // handleCheckChange(node,list){
      //   this.ruleForm.parentId=node.id;
      //   //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
      //   if (list.checkedKeys.length == 2) {
      //     //单选实现
      //     this.$refs.selectTree.setCheckedKeys([node.id]);
      //   }
      // },
      chooseCodeType() {
        let val = this.ruleForm.codeType;
        if (val == 0) {
          //原材料
          this.getAllClass(1);
          this.codeType = 1;
          this.getWarehouseList(0);
        } else if (val == 1) {
          this.getAllClass(0);
          this.codeType = 0;
          this.getWarehouseList(1);
        } else if (val == 2) {
          this.getAllClass(0);
          this.codeType = 0;
          this.getWarehouseList(2);
        }
      },
      setClassRef(index) {
        return `itemRef-${index}`;
      },
      getAllClass(classType) {
        let params = {
          pageNum: 1,
          pageSize: 200,
          type: 0,
          classType: classType,
        };
        pageClassList(params).then((res) => {
          res.data.list.forEach((item) => {
            item.isLeaf = !item.hasChildren;
            let namePart = item.name ? `${item.name}` : "";
            let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
            let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
            let specNamePart = item.specName ? `(${item.specName})` : "";
            item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
          });
          this.classList = [{ id: "", allName: "顶级", children: res.data.list }];
          this.allData = JSON.parse(JSON.stringify(this.classList));
          this.$forceUpdate();
        });
      },
      delTag(item, index) {
        let number = this.ruleForm.addStoreCodeDtos[index].parentId.findIndex(
          (val) => val.name == item || val.name + "(" + val.specName + ")" == item
        );
        this.ruleForm.addStoreCodeDtos[index].parentId.splice(number, 1);
        this.ruleForm.addStoreCodeDtos[index].parentName =
          this.ruleForm.addStoreCodeDtos[index].parentId.map((val) =>
            val.specName ? val.name + "(" + val.specName + ")" : val.name
          );
        this.ruleForm.addStoreCodeDtos[index].name =
          this.ruleForm.addStoreCodeDtos[index].parentName
            .map((val) => val)
            .join(",");
      },
      getChildrenList(data, arr) {
        if (data.children && data.children.length > 0) {
          data.children.forEach((item) => {
            this.getChildrenList(item, arr);
          });
        } else {
          arr.push(data);
        }
        return arr;
      }, 
      checkChildrenData(obj) {
        if (!obj.children) {
          return false;
        } else {
          obj.children.forEach((item) => {
            if (item.hasChildren) {
              this.checkChildrenData(item);
            }
          });
        }
        return true;
      },
      handleNodeClick(obj, node, item, index) {
        if (!obj.id) {
          this.$message.error("请选择下级节点");
          return;
        }
        // if (obj.hasChildren) {
        //   let flag = this.checkChildrenData(obj);
        //   if (!flag) {
        //     this.$message.error("请点击箭头加载子级数据");
        //     return;
        //   }
        // }
        let selectedNodes = [];
        if (this.selectionMode === 'single') {
          // 单选模式：只选择当前节点
          selectedNodes.push(obj);
        } else {
          // 包含子节点模式：获取所有子孙节点
          selectedNodes = this.getChildrenList(obj, []);
        }
        // let childrenList = this.getChildrenList(obj, []);
        // console.log('childrenList',childrenList)
        // if (data.children && data.children.length > 0){
        //   this.$message.error("请选择子级节点")
        //   return;
        // }
        selectedNodes.forEach((data) => {
          let number = this.ruleForm.addStoreCodeDtos[index].parentId.findIndex(
            (val) => val.id == data.id
          );
          if (number && number == -1) {
            // if (data.parentId) {
            //   let number1 = this.ruleForm.addStoreCodeDtos[
            //     index
            //   ].parentId.findIndex((val) => val.id == data.parentId);
            //   if (number1 != -1) {
            //     this.$message.error("该节点父级已被选择");
            //     return;
            //   }
            // }
            if (data.parentId) {
              let parentIndex = this.ruleForm.addStoreCodeDtos[index].parentId.findIndex((val) => val.id == data.parentId);
              if (parentIndex !== -1 && this.selectionMode === 'single') {
                this.$message.error("该节点父级已被选择");
                return;
              }
            }
            this.ruleForm.addStoreCodeDtos[index].parentId =
              this.ruleForm.addStoreCodeDtos[index].parentId.filter(
                (val) => val.parentId != data.id
              );
            this.ruleForm.addStoreCodeDtos[index].parentId.push({
              id: data.id,
              name: data.name,
              parentId: data.parentId,
              specName: data.specName,
            });
          }
          this.ruleForm.addStoreCodeDtos[index].parentName =
            this.ruleForm.addStoreCodeDtos[index].parentId.map((val) =>
              val.specName ? val.name + "(" + val.specName + ")" : val.name
            );
          this.ruleForm.addStoreCodeDtos[index].name =
            this.ruleForm.addStoreCodeDtos[index].parentName
              .map((val) => val)
              .join(",");
          let classRef = this.setClassRef(index);
          this.$nextTick(() => {
            this.$refs[classRef][0].blur();
          });
        });
      },
      setValueNull(index) {
        this.ruleForm.addStoreCodeDtos[index].parentId = [];
        this.ruleForm.addStoreCodeDtos[index].parentName = [];
        this.ruleForm.addStoreCodeDtos[index].name = "";
      },
      optionData(array, result = []) {
        array.forEach((item) => {
          result.push({
            label: item.specName
              ? item.name + "(" + item.specName + ")"
              : item.name,
            value: item.id,
          });
          if (item.children && item.children.length !== 0) {
            this.optionData(item.children, result);
          }
        });
        return JSON.parse(JSON.stringify(result));
      },
      getWarehouseList(warehouseType) {
        fetchWarehouseTree({ warehouseType: warehouseType }).then((res) => {
          this.warehouseList = res.data;
        });
      },
      getClssList() {
        this.getAllClass();
        // noPage({classType: 0}).then(res => {
        //   this.classList = this.classList = [{id:'',name:'顶级',children:res.data}]
        // })
      },
      removeDomain(item, index) {
        if (this.ruleForm.addStoreCodeDtos.length == 1) {
          return this.$message({
            message: "最少保留一条产品信息",
            type: "warning",
          });
        } else {
          this.ruleForm.addStoreCodeDtos.splice(index, 1);
        }
      },
      addClass(index) {
        this.ruleForm.addStoreCodeDtos[index].storeCodeDtos.push({
          classId: "",
          num: 0,
        });
      },
      delClass(index, cIndex) {
        this.ruleForm.addStoreCodeDtos[index].storeCodeDtos.splice(cIndex, 1);
      },
      addSpec() {
        this.ruleForm.addStoreCodeDtos.push({
          num: 1,
          parentName: [],
          parentId: [],
          isMaterial: false,
          name: "",
          warehouseId: "",
          warehouseIds: "",
          storeCodeDtos: [{ classId: "", num: 1 }],
          img: "",
          remarks: "",
          fileList: [],
        });
      },
      delSpec(index) {
        this.ruleForm.addStoreCodeDtos.splice(index, 1);
      },
      goBack() {
        this.$router.push({ path: "/store/code" });
      },
      confirm() {
        this.$refs.dynamicValidateForm.validate((valid) => {
          if (valid) {
            this.ruleForm.addStoreCodeDtos.forEach((item) => {
              item.warehouseId = item.warehouseIds[item.warehouseIds.length - 1];
              item.classIds = item.parentId.map((val) => val.id);
              delete item.fileList;
            });
            addStoreCode(this.ruleForm).then((res) => {
              this.goBack();
            });
          }
        });
      },
      changeType() {
        if (this.ruleForm.type == 0) {
          this.typeShow = true;
        } else if (this.ruleForm.type == 1) {
          this.typeShow = false;
        }
      },
      handleAddPageClass(type, index) {
        if (this.ruleForm.codeType == 0) {
          this.$refs.AddMaterialDialog.openDialog(type, this.classType);
        } else {
          this.$refs.addPageClassDialog.openDialog(type, this.classType);
        }
        this.currentTypeIndex = index;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10 rpx;
  }

  .children-item {
    width: 50%;
  }

  .orderTitle {
    font-size: 16px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    padding: 0px 60px 6px 55px;
  }

  .main-select-tree {
    /deep/.el-input__inner {
      height: 80px !important;
    }

    /deep/ .el-select__tags {
      display: flex;
      overflow: auto;
      max-height: 80px;
    }
  }

  .subBtn {
    text-align: center;
  }

  .codeType {}

  .codeWrap {
    margin-top: 20px;

    /deep/ .el-upload--text {
      width: 150px !important;
      height: 150px !important;
    }
  }

  /deep/ .disabled .el-upload--picture-card {
    display: none;
  }

  .corporateInformation-view {
    padding: 16px 24px;
  }

  /deep/.el-tabs__content {
    background: #ffffff;
  }

  .searchItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    .searchName {
      width: 130px;
      font-size: 14px;
    }
  }

  .tree-container {
    height: 400px;
    overflow-y: auto;
  }

  .virtual-scroller {
    width: 100%;
  }
</style>